// src/components/cooler/inventory/components/ItemDetails/utils.ts

export const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat('en-IE', {
    style: 'currency',
    currency: 'EUR'
  }).format(amount);
};